export const getServicePrice = (amountPerUnit?: number, quantity?: number) =>
	(amountPerUnit ?? 0) * (quantity ?? 1)
